export interface IFileMetadata {
  readonly duration: number
  readonly width: number
  readonly height: number
}

export function getFileMetadata(file: File): Promise<IFileMetadata | undefined> {
  return new Promise((resolve) => {
    const isAudio = ['mp3', 'wav', 'ogg'].includes(file.name.split('.').pop()?.toLowerCase() ?? '')
    const mediaElement = document.createElement(isAudio ? 'audio' : 'video')

    mediaElement.preload = 'metadata'
    const objectUrl = URL.createObjectURL(file)
    mediaElement.src = objectUrl

    const cleanup = () => {
      mediaElement.removeAttribute('src')
      mediaElement.load()
      URL.revokeObjectURL(objectUrl)
    }

    mediaElement.onloadedmetadata = () => {
      const videoElement = mediaElement instanceof HTMLVideoElement ? mediaElement : undefined
      resolve({
        duration: mediaElement.duration,
        width: videoElement?.videoWidth ?? 0,
        height: videoElement?.videoHeight ?? 0,
      })
      setTimeout(cleanup, 0)
    }

    mediaElement.onerror = () => {
      setTimeout(cleanup, 0)
      resolve(undefined)
    }
  })
}

export default async function getFileDuration(file: File): Promise<number | undefined> {
  return (await getFileMetadata(file))?.duration
}
